module.exports = __webpack_public_path__ + "img/alloys@2x.c46622e.webp";